import Vue from 'vue'
import ElementUI from 'element-ui'
import ICSUI from 'ics-ui'
import 'normalize.css/normalize.css'
import 'ics-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.use(ICSUI)
